var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRow22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2849 45.0176H21.8019V40.9863C20.8926 41.1253 19.9516 41.2002 19 41.2002C18.0484 41.2002 17.118 41.1253 16.1981 40.9863V45.0176H11.7151C9.24096 45.0176 7.23206 47.0493 7.23206 49.5514V52.0108H30.7574V49.5514C30.7574 47.0493 28.7485 45.0176 26.2743 45.0176H26.2849Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.463 9.57022C28.463 4.29858 24.2126 0 19 0C13.7874 0 9.52643 4.29858 9.52643 9.57022V14.1147H28.463V9.57022Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 32.0039C24.2231 32.0039 28.463 27.7053 28.463 22.4337V17.8892H9.52643V22.4337C9.52643 27.716 13.7768 32.0039 18.9894 32.0039H19Z",
    fill: "#00B1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7585 18.6484H31.212V22.4338C31.212 29.2345 25.7351 34.7735 19 34.7735C12.2649 34.7735 6.79855 29.2345 6.79855 22.4338V18.6484H2.24151C1.00445 18.6484 0 19.6643 0 20.9153C0 22.1664 1.00445 23.1823 2.24151 23.1823H2.70673C3.09794 31.9291 10.256 38.933 19 38.933C27.744 38.933 34.9126 31.9291 35.2933 23.1823H35.7585C36.9955 23.1823 38 22.1664 38 20.9153C38 19.6643 36.9955 18.6484 35.7585 18.6484Z",
    fill: "#00B1A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_2019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow22);
export default __webpack_public_path__ + "static/media/row2-2.fd80fe9176b83a49a2d2cf36cb21e838.svg";
export { ForwardRef as ReactComponent };